import { observer } from "mobx-react";
import React, { Component } from "react";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import voiceStore from "../../stores/voiceStore";

const withNavigation = (WrappedComponent) => {
  return (props) => {
    const navigate = useNavigate();
    return <WrappedComponent {...props} navigate={navigate} />;
  };
};

const SearchByLanguageModal = observer(
  class SearchByLanguageModal extends Component {
    constructor(props) {
      super(props);
      this.state = {
        selectedLanguages: [],
      };
    }

    handleLanguageSelect = (data) => {
      this.setState({ selectedLanguages: data });
    };

    handleAccentSelect = (data) => {
      this.setState({ selectedAccents: data });
    };

    handleSearch = async () => {
      const { selectedLanguages, selectedAccents } = this.state;
      const payload = {
        ...(selectedLanguages &&
          selectedLanguages.length > 0 && {
            languages: selectedLanguages.map((language) => language.value),
          }),
        ...(selectedAccents &&
          selectedAccents.length > 0 && {
            accents: selectedAccents.map((accent) => accent.value),
          }),
      };

      const result = await voiceStore.searchVoice(payload);
      if (result) {
        this.props.navigate("/search-results");
      } else {
        console.error("Error =>", result);
      }
    };

    handleOverlayClick = (event) => {
      if (event.target === event.currentTarget) {
        this.props.closeModal();
      }
    };

    componentDidMount() {
      document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (event) => {
      if (event.key === "Escape") {
        this.props.closeModal();
      }
    };

    render() {
      const { accentOptions, languageOptions } = voiceStore.normalDropdownData;

      return (
        <div
          onClick={this.handleOverlayClick}
          className="fixed inset-0 flex flex-1 w-full items-center overflow-y-scroll lg:overflow-hidden justify-center bg-black bg-opacity-50 z-10"
        >
          <div className="lg:fixed h-full lg:h-auto flex flex-col w-full lg:w-[40%] bg-white p-6 rounded-lg shadow-lg pt-24 lg:pt-0">
            <h2 className="font-bold text-3xl text-[#21272A] mb-4 pt-6">{`Search By Language`}</h2>
            <span className="font-normal text-base text-[#21272A]"></span>
            <FaTimes
              onClick={this.props.closeModal}
              className="absolute right-5 top-5 hover:cursor-pointer"
              size={20}
              color="black"
            ></FaTimes>
            {/* Language */}
            <div className="flex lg:flex-1 flex-col lg:flex-row w-full gap-3 mt-14">
              <div className="flex flex-col lg:flex-1">
                <span className="font-semibold text-base text-[#21272A] mb-2">
                  Language
                </span>
                <div>
                  <Select
                    options={languageOptions}
                    placeholder=""
                    value={this.state.selectedLanguages}
                    onChange={this.handleLanguageSelect}
                    isSearchable={true}
                    isMulti
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: "#F0EFEF",
                        color: "#FFF",
                        paddingTop: 5,
                        paddingBottom: 5,
                        boxShadow: "none",
                        border: "1px solid #ccc",
                        "&:hover": {
                          border: "1px solid #ccc",
                        },
                      }),
                      indicatorsContainer: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: "#B7B7B7",
                        borderRadius: 6,
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        color: "#130D0D",
                        paddingRight: 10,
                        paddingLeft: 16,
                        paddingTop: 10,
                        paddingBottom: 10,
                      }),
                      multiValueRemove: (provided) => ({
                        ...provided,
                        color: "#130D0D",
                        ":hover": {
                          backgroundColor: "#B7B7B7",
                          color: "#130D0D",
                          borderRadius: 6,
                        },
                      }),
                    }}
                  />
                </div>
              </div>

              {/* Accent */}
              <div className="flex flex-col lg:flex-1">
                <span className="font-semibold text-base text-[#21272A] mb-2">
                  Accent
                </span>
                <div>
                  <Select
                    options={accentOptions}
                    placeholder=""
                    value={this.state.selectedAccents}
                    onChange={this.handleAccentSelect}
                    isSearchable={true}
                    isMulti
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: "#F0EFEF",
                        color: "#FFF",
                        paddingTop: 5,
                        paddingBottom: 5,
                        boxShadow: "none",
                        border: "1px solid #ccc",
                        "&:hover": {
                          border: "1px solid #ccc",
                        },
                      }),
                      indicatorsContainer: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: "#B7B7B7",
                        borderRadius: 6,
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        color: "#130D0D",
                        paddingRight: 10,
                        paddingLeft: 16,
                        paddingTop: 10,
                        paddingBottom: 10,
                      }),
                      multiValueRemove: (provided) => ({
                        ...provided,
                        color: "#130D0D",
                        ":hover": {
                          backgroundColor: "#B7B7B7",
                          color: "#130D0D",
                          borderRadius: 6,
                        },
                      }),
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="mt-24 flex justify-end gap-2">
              <button
                className="text-white font-medium text-base px-6 py-2 rounded-md bg-[#130D0D]"
                onClick={this.handleSearch}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
);

export default withNavigation(SearchByLanguageModal);
